import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
} from "@alaffia-technology-solutions/ds";

interface ErrorMessageProps {
  error: string | null;
}

export const PDFErrorMessage = ({ error }: ErrorMessageProps) => {
  return (
    <div className="af-flex af-h-full af-w-full af-items-center af-justify-center">
      <Alert variant="destructive" className="af-mx-auto af-w-max">
        <AlertIcon />
        <AlertTitle>Error</AlertTitle>
        <AlertDescription>{error}</AlertDescription>
      </Alert>
    </div>
  );
};
